import { Button } from 'primereact/button'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { InputText } from 'primereact/inputtext'
import React, { useState } from 'react'
import { RootState } from '../reducers'
import { useSelector } from 'react-redux';
import { fetchDocData, UploadImageData } from '../reduxactions/suprivisoractions/SupDocumentsActions';
import { useDispatch } from 'react-redux'
import useEffectOnce from '../hooks/useEffectOnce'
import { Dialog } from 'primereact/dialog'
import { FileUpload, FileUploadHandlerEvent } from 'primereact/fileupload'
import { SUPRIVISOR_API } from '../ApiNames'
import { LoginService } from '../services/LoginService';
import { Admin_API } from '../ApiNames';


export const SupViewDocuments = () => {
  const uid = window.sessionStorage.getItem('uid');
  const usertype = window.sessionStorage.getItem('usertype');

  const [globalFilter, setGlobalFilter] = useState('');

  const data = useSelector((state: RootState) => state.sdoc.data);






  const dispatch = useDispatch();

  //To get data
  const fetchDataAsync = async () => {
    try {
      await dispatch(fetchDocData(uid) as any);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  useEffectOnce(() => {
    fetchDataAsync();

  }, [dispatch]);
  const [Adddocument, setAdddocument] = useState(false);
  const [docname, setDocument] = useState<string>('');
  const [selectedFile, setSelectFile] = useState<File | null>(null);
  const close = () => {
    setAdddocument(false);
  }
  const images = useSelector((state: RootState) => state.sviewapprovedapplication.image);

  const UploadManagerImage = async (event: FileUploadHandlerEvent) => {
    const files = event.files;
    if (files.length > 0) {
      const file = files[0];
      console.log('file:', file);
      setSelectFile(file);
    }
  };

  const handleSubmit = async () => {
    if (docname && selectedFile) {
      try {
        await dispatch(UploadImageData(selectedFile, uid, docname) as any);
        console.log('Image and document title submitted successfully!');
        setAdddocument(false);
        window.location.reload();
      } catch (error) {
        console.error('Error submitting the form:', error);
      }
    } else {
      console.log('Please fill in all fields (title and file).');
    }
  };
  const [uplodata, setuplodata] = useState<[]>([]);


  const getuploddata = async () => {
    try {
      const payload = { uid: uid };
      const apiname = Admin_API.upload_API;
      const data1 = await LoginService.getData(apiname, payload);
      setuplodata(data1);
    } catch (error) {

    }
  };

  const [ViewDilog, setViewDilog] = useState(false);

  const viewPage = (rowData: any) => {
    getuploddata()

    setViewDilog(true);
  }
  //for help
  const [openHelp, setHelp] = useState(false);
  const url1 = window.sessionStorage.getItem("apiRoot");
  const IUrl = `${url1}/help/viewdocument.php`;
  const helpImg = `${url1}/help/help3.png`;
  const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
    event.preventDefault();
    const newWindowReference = window.open(
      targetUrl,
      'newwindow',
      'width=1000,height=1000,noopener,noreferrer'
    );

    if (newWindowReference) {
      newWindowReference.opener = null;
    }
  };
  return (
    <div style={{ marginLeft: '260px' }}>
      <div className="content-wrapper">
        <section className="content-header">
          <div className="container-fluid">
            <div className="grid mb-2">
              <div className="col-6">
              </div>
            </div>
          </div>
        </section>
        <section className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="card-header p-2" style={{ marginTop: '50px' }}>
                <h2>Uploads</h2>
              </div>
              <div className="col-16" style={{ textAlign: "right" }}>
                <a
                  title="help"
                  onClick={(e) => openWindow(e, IUrl)}
                  style={{

                    color: "blue",
                    fontSize: 15, cursor: "pointer"
                  }}
                >Help for this Page &nbsp;
                  <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                </a>
              </div>
              <br></br>
              <div className="card flex flex-wrap justify-content-end">
                <Button label="Add Uploads" severity="info" onClick={() => setAdddocument(true)} style={{ marginRight: '50px', background: "rgba(59,130,246,.04)", color: "#3b82f6", border: "1px solid" }} />
              </div>
              <div className="box box-primary">
                <div className="card">
                  <p className="m-0">
                    <div>
                      <div className="card flex flex-wrap justify-content">
                        <span className="p-input-icon-left">
                          <i className="pi pi-search" style={{ paddingLeft: '5px' }} />
                          <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" style={{ paddingLeft: '25px' }} />
                        </span>

                      </div>
                      <DataTable value={data} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >
                        <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>

                        <Column field="docname" sortable header="File Name"></Column>
                        <Column field="CreateDate" sortable header="Uploaded Date "></Column>

                        <Column header="Option" body={(rowData) => (

                          <div className="options-buttons">

                            <Button className='mr-1' tooltip="View" severity="info" icon="pi pi-eye" rounded outlined onClick={() => viewPage(rowData)} />

                          </div>
                        )}></Column>
                      </DataTable>

                    </div>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Dialog header="Upload Document" visible={Adddocument} style={{ width: '30vw', height: '40' }} onHide={() => setAdddocument(false)}>
        <div className="grid pt-0" style={{ marginBottom: '2px' }}>
          <div className="col-3">
            <label htmlFor="name" className="col-sm-2 control-label">
              Doc Title:
            </label>
          </div>
          <div className="col-6">
            <InputText
              id="name"
              style={{ width: '18vw', marginBottom: '20px', marginLeft: '25px' }}
              type="text"
              value={docname}
              name="Doc Title"
              placeholder="Document Title"
              onChange={(e) => setDocument(e.target.value)}
            />
          </div>
        </div>
        <div className="grid pt-0" style={{ marginBottom: '2px' }}>
          <div className="col-3">
            <label htmlFor="file" className="col-sm-2 control-label">
              Select File:
            </label>
          </div>
          <div className="col-6" style={{ marginLeft: '30px' }}>
            <FileUpload
              mode="basic"
              id="fileToUpload"
              name="fileToUpload"
              customUpload
              accept="image/*"
              maxFileSize={1000000}
              uploadHandler={UploadManagerImage}
              auto
            />
            {selectedFile && <p style={{ marginTop: '10px' }}>{selectedFile.name}</p>}
          </div>
        </div>

        {/* Action Buttons */}
        <div className="p-d-flex p-jc-between">
          <Button label="Close" onClick={() => setAdddocument(false)} severity="secondary" />
          <Button label="Add" onClick={handleSubmit} style={{ marginLeft: '10px', float: 'right' }} />
        </div>
      </Dialog>
      <Dialog header="View" style={{ width: '50vw' }} visible={ViewDilog} onHide={() => setViewDilog(false)}>
        <div className="modal-header">
        </div>
        <div className="modal-body">
          {uplodata.map((response: any, index: number) =>
            <div key={index}>
              <img src={response.image} alt="Doc" width="100%" height="auto" />
            </div>
          )}
        </div>
      </Dialog>



    </div>)
}
